const al = {
 "studio": "Resource Studio",
 "studioSub": "Finden → Vorschau → Anpassen → Zuweisen. Testsatz: {n} Materialien.",
 "search": "Materialien suchen",
 "all": "Alle",
 "language": "Sprache",
 "level": "Niveau",
 "type": "Typ",
 "eligibility": "Verfügbar in",
 "why": "Warum das passt",
 "reg": {"label": "Register", "unspecified": "Nicht angegeben", "v": {"formal": "Formell", "informal": "Informell", "mixed": "Gemischt", "neutral_na": "Neutral / nicht relevant"}, "edit": "Bearbeiten", "choose": "Register wählen", "notePh": "Kurze Notiz (optional)", "notePhMixed": "Wer nutzt welche Form? (bei gemischt Pflicht)", "noteNeeded": "Gemischtes Register braucht eine kurze Notiz.", "saved": "Register gespeichert. Aktivitätstext unverändert."},
 "teacherOnly": "Nur Lehrkräfte",
 "answerKey": "Lösungen",
 "rubric": "Bewertungsraster",
 "notes": "Hinweise für Lehrkräfte",
 "preview": "Schüleransicht",
 "adapt": "Anpassen",
 "assign": "Der Klasse zuweisen",
 "assigned": "Deiner Klasse zugewiesen.",
 "adapted": "Deine angepasste Kopie wurde gespeichert. Das Original bleibt unverändert.",
 "titleLabel": "Titel",
 "instructionsLabel": "Anweisungen für Lernende",
 "save": "Kopie speichern",
 "cancel": "Abbrechen",
 "noResults": "Keine Materialien passen zu diesen Filtern.",
 "previewNote": "Testinhalt — nicht Teil der künftigen Bibliothek",
 "lab": "Discovery Lab",
 "labSub": "Entdecken → ausprobieren → verstehen → anwenden. Ein paar kleine Aktivitäten zum Erkunden.",
 "secTry": "Probier das",
 "secPattern": "Entdecke ein Muster",
 "secSolve": "Löse etwas",
 "secRead": "Lies und entdecke",
 "check": "Prüfen",
 "score": "{c} von {t} richtig",
 "tryAgain": "Nochmal versuchen",
 "done": "Fertig",
 "know": "Weiß ich",
 "again": "Nochmal",
 "flip": "Zum Umdrehen tippen",
 "keep": "Für mein eigenes Üben behalten",
 "kept": "In deiner Vokabelbank gespeichert.",
 "cantKeep": "Die Sprache dieses Sets ist keine deiner Lernsprachen, daher kann es nicht gespeichert werden.",
 "practiceDone": "Übung für deine Klasse gespeichert.",
 "results": "Klassenergebnisse",
 "completed": "Abgeschlossen",
 "attempted": "Begonnen",
 "notAttempted": "Nicht begonnen",
 "classResources": "Klassenmaterialien",
 "open": "Öffnen",
 "minutes": "{n} Min.",
 "failed": "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
 "close": "Schließen",
 "cardOf": "{i} / {n}",
 "pickClass": "Klasse wählen",
 "mine": "Meine Anpassungen",
 "explored": "Erkundet",
 "fam": {
  "grammar": "Grammatik",
  "worksheet": "Arbeitsblatt",
  "memory": "Karteikarten",
  "game": "Rätsel",
  "form": "Formular",
  "document": "Alltagsdokument",
  "speaking": "Sprechen",
  "reading": "Lesen & Kultur",
  "assessment": "Bewertung",
  "data": "Daten-Challenge"
 },
 "elig": {
  "public": "Öffentlich",
  "pro": "Pro",
  "education": "Bildung"
 }
};
al.p = {
 "sev": {"low": "Niedrig", "medium": "Mittel", "high": "Hoch"},
 "area": {"language_accuracy": "Sprachrichtigkeit", "naturalness": "Natürlichkeit", "cefr_fit": "GER-Niveau", "answer_key": "Lösungen", "instructions": "Anweisungen", "pedagogy": "Didaktik", "culture_stereotypes": "Kultur & Stereotype", "duplication": "Dopplungen", "formatting_script": "Format & Schrift", "provenance": "Herkunft", "objective_alignment": "Zielausrichtung", "teacher_learner_match": "Lehrkraft/Lernende stimmig"},
 "edited": "bearbeitet",
 "precheck": "KI-Vorprüfung",
 "precheckRun": "KI-Vorprüfung starten",
 "precheckRerun": "Erneut",
 "precheckNone": "Noch keine Vorprüfung.",
 "precheckStale": "ältere Version",
 "corrections": "{n} Korrekturvorschläge (nicht angewendet)",
 "precheckAdvisory": "Nur beratend: gibt nie frei und ändert nichts.",
 "pv": {"pass": "KI: ok", "revise": "KI: überarbeiten", "attention": "KI: menschliche Prüfung nötig"},
 "badJson": "Ungültiges JSON.",
 "contentSaved": "Inhalt gespeichert; der alte Stand bleibt im Protokoll.",
 "editContent": "Inhalt bearbeiten",
 "editTrail": "Jede Änderung wird mit dem vorherigen Inhalt protokolliert.",
 "history": "Versionen",
 "startRevision": "Überarbeitung starten",
 "revisionStarted": "Entwurf v{v} erstellt. Die freigegebene Version bleibt aktiv.",
 "histAssign": "{n} Zuweisungen behalten ihre eingefrorene Version.",
 "confirmElig": "Verfügbarkeit geprüft: {e}",
 "confirmEligFirst": "Bestätige zuerst die Verfügbarkeit.",
 "objective": "Ziel",
 "provenance": "Herkunft",
 "wave": "Welle filtern",
 "booklet": "Stundenheft",
 "summary": "Übersichts-PDF",
 "showMore": "{n} weitere anzeigen",
 "showLess": "Weniger anzeigen",
 "checklistIncomplete": "Markiere zuerst jeden Punkt der Checkliste.",
 "across": "Waagerecht",
 "down": "Senkrecht",
 "clueListNote": "Schreibe jede Antwort neben ihre Nummer. Die Zahl in Klammern ist die Buchstabenanzahl.",
 "again": "Nochmal üben",
 "exportVersion": "Version",
 "print": "Drucken",
 "export": "Exportieren",
 "theme": "Thema",
 "grammar": "Grammatik",
 "vocab": "Wortschatz",
 "function": "Sprachfunktion",
 "duration": "Minuten",
 "teacherInstr": "Hinweise für die KI (optional)",
 "canonical": "Kanonischer GetFluentLoop-Entwurf (geht in die Prüfung)",
 "draftSaved": "Entwurf gespeichert. Er bleibt privat, bis du ihn als bereit markierst.",
 "draftNote": "KI-Entwurf: Sprache, Niveau und Lösungen vor dem Speichern prüfen.",
 "fromFile": "Erstellt aus",
 "saveDraft": "Entwurf speichern",
 "uploaded": "Datei zu deinen Dateien hochgeladen.",
 "aiNote": "KI-Entwürfe starten immer privat. Nichts wird automatisch veröffentlicht oder zugewiesen.",
 "uploadNote": "Lade ein PDF, Word, Text, CSV oder Excel hoch. Das Original bleibt unverändert; die Aktivität ist ein eigener privater Entwurf.",
 "uploadedAs": "als Material gespeichert.",
 "useAsResource": "Als Material nutzen ✓",
 "orCreate": "oder unten eine Aktivität daraus erstellen:",
 "generating": "Wird erstellt…",
 "generate": "Entwurf erstellen",
 "createFromFile": "Daraus eine Aktivität erstellen",
 "suggestedBy": "Von einer Lehrkraft vorgeschlagen",
 "checklist": "Qualitäts-Checkliste",
 "checklistNote": "Menschliche Prüfung. Jeden Punkt markieren; Bedenken vorher klären.",
 "reviewNote": "Prüf- / Freigabenotiz (intern)",
 "reviewSub": "Redaktionsliste für kanonische GetFluentLoop-Inhalte. Notizen bleiben intern.",
 "reviewEmpty": "Hier ist nichts.",
 "packName": "Paketname",
 "packCreated": "Paket erstellt.",
 "packsSub": "Pakete bündeln Materialien, Missionen und Dateien. Persönliche Pakete bleiben privat, außer eine Schuladmin teilt sie.",
 "createPack": "Paket erstellen",
 "packsEmpty": "Noch keine Pakete.",
 "school": "Schule",
 "private": "Privat",
 "packSaved": "Als Paket gespeichert.",
 "subSub": "Stellt eine Vertretungsstunde nur aus freigegebenen Materialien zusammen, ohne KI.",
 "themeOptional": "Thema (optional)",
 "buildLesson": "Stunde zusammenstellen",
 "lessonTotal": "Stunde: {n} Min. (gewünscht {r})",
 "mission": "Mission",
 "missing": "Noch kein freigegebenes Material",
 "subNote": "Jeden Teil im Resource Studio drucken. Lösungen bleiben bei der Lehrkraft.",
 "savePack": "Als Paket speichern",
 "linked": "Zur Mission hinzugefügt.",
 "useInMission": "In einer Mission nutzen",
 "startMission": "Missionsentwurf starten",
 "orExisting": "oder einer gespeicherten Mission anhängen:",
 "noMissions": "Keine gespeicherten Missionen in dieser Sprache.",
 "attach": "Anhängen",
 "addedToPack": "Zum Paket hinzugefügt.",
 "choosePack": "Paket wählen",
 "addToPack": "Zum Paket",
 "readyDone": "Bereit zum Zuweisen.",
 "markReady": "Als bereit markieren",
 "unshared": "Nicht mehr geteilt.",
 "shared": "Mit deiner Schule geteilt.",
 "unshare": "Nicht mehr teilen",
 "share": "Mit der Schule teilen",
 "suggest": "Für die GetFluentLoop-Bibliothek vorschlagen",
 "draftPrivate": "Privater Entwurf: nur du siehst ihn. Als bereit markieren, um ihn zuzuweisen.",
 "suggestNote": "Es entsteht eine separate Prüfkopie für die GetFluentLoop-Redaktion. Deine Version bleibt unverändert.",
 "rights": "Deine Rechte zum Teilen",
 "suggestNotePh": "Hinweis für die Redaktion (optional)",
 "suggested": "An die GetFluentLoop-Prüfung gesendet.",
 "send": "Senden",
 "denied": "Resource Studio ist für verifizierte Lehrkräfte.",
 "draftNoAssign": "Vor dem Zuweisen als bereit markieren.",
 "schoolShared": "In meiner Schule geteilt",
 "missionResources": "Materialien zu dieser Mission",
 "attachResources": "Materialien anhängen (gleiche Sprache)",
 "noCompatible": "Keine bereiten Materialien in dieser Sprache.",
 "previewCombined": "Vorschau mit Materialien",
 "pickMissionFor": "Wähle eine Mission für {id} ({lang}) und hänge es beim Zuweisen an.",
 "ver": {
  "learner": "Arbeitsblatt",
  "teacher": "Lehrkraftversion",
  "answer_key": "Lösungsschlüssel",
  "teacher_guide": "Lehrkraft-Leitfaden"
 },
 "grp": {
  "individual": "Einzeln",
  "pairs": "Paare",
  "groups": "Gruppen",
  "whole_class": "Ganze Klasse"
 },
 "mode": {
  "ai": "KI-Entwurf",
  "upload": "Aus einer Datei"
 },
 "out": {
  "worksheet": "Arbeitsblatt",
  "grammar_discovery": "Grammatik entdecken",
  "flashcards": "Karteikarten",
  "crossword": "Kreuzworträtsel / Rätsel",
  "interactive_form": "Interaktives Formular",
  "reading": "Lesetext",
  "speaking_cards": "Sprechkarten",
  "exit_ticket": "Exit-Ticket",
  "data_challenge": "Daten-Challenge"
 },
 "st": {
  "draft": "Entwurf",
  "reviewed": "Geprüft",
  "approved": "Freigegeben",
  "retired": "Zurückgezogen",
  "superseded": "Ersetzt",
  "teacher_ready": "Bereit"
 },
 "cv": {
  "pass": "OK",
  "concern": "Bedenken",
  "na": "n. z."
 },
 "do": {
  "reviewed": "Als geprüft markieren",
  "approved": "Freigeben",
  "draft": "Zurück zum Entwurf",
  "retired": "Zurückziehen"
 },
 "pp": {
  "warmups": "10-Minuten-Einstiege",
  "speaking": "Sprechwoche",
  "revision": "Prüfungsvorbereitung",
  "reading": "Lesewoche",
  "grammar": "Grammatik entdecken",
  "substitute": "Vertretung",
  "other": "Sonstiges"
 },
 "slot": {
  "starter": "Einstieg",
  "main": "Hauptaktivität",
  "speaking": "Sprechen",
  "resource": "Arbeitsblatt / Material",
  "exit": "Exit-Ticket"
 },
 "rt": {
  "own_work": "Eigenes Werk",
  "cc_by": "CC BY",
  "cc0": "CC0",
  "public_domain": "Gemeinfrei",
  "licensed_for_reuse": "Zur Wiederverwendung lizenziert"
 },
 "tab": {
  "library": "Bibliothek",
  "create": "Erstellen",
  "packs": "Pakete",
  "substitute": "Vertretungspaket",
  "review": "Prüfung"
 },
 "ck": {
  "language_correct": "Sprache korrekt",
  "cefr_fit": "GER-Niveau passt",
  "objective_clear": "Klares Ziel",
  "meaningful_language_use": "Erfordert echten Sprachgebrauch",
  "learner_instructions": "Lernenden-Anweisungen klar",
  "teacher_instructions": "Lehrkraft-Anweisungen klar",
  "cultural_credibility": "Kulturell glaubwürdig",
  "stereotype_risk": "Keine Stereotype",
  "age_context": "Alters- und kontextgerecht",
  "copyright_provenance": "Urheberrecht / Herkunft OK",
  "privacy": "Keine personenbezogenen Daten",
  "cards_accurate": "Karten korrekt",
  "roles_balanced": "Rollen ausgewogen",
  "data_plausible": "Daten plausibel",
  "answer_key_correct": "Lösungen korrekt",
  "puzzle_solvable": "Rätsel lösbar",
  "text_level": "Text auf passendem Niveau",
  "authentic_format": "Authentisches Format",
  "realistic_form": "Realistisches Formular"
 }
};
export default al;
